export default {"src":"/_next/static/media/usdt0.86867de2.svg","height":977,"width":976,"blurWidth":0,"blurHeight":0};